import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { WsSliceState, wsSlice, WsOnMessage, WsTopic } from '@wellesley/ws'
import { useCurrentUser } from '@wellesley/user'
import { Notification } from '@wellesley/openapi'

import { notificationsSlice } from '../../slice'
import {
  undoNotification,
  addNotification,
  wsSubscribe,
  wsUnSubscribe,
} from '@wellesley/host-remote/api/actions'
import isUndoNotification from '../../helpers/isUndoNotification'
import { notify } from '../../components/CustomToast'
import NotificationBody from '../../components/NotificationBody'
// import commentedPostNotification from 'testing/mocks/notifications/mockCommentedPost'

const topic: WsTopic = 'notification'

export const useNotifications = () => {
  const dispatch = useDispatch()

  //todo: inline notifications will be removed
  const canNotify = false

  // const canNotify =
  //   mergedSettings?.notifications.stranger[
  //     'user.notifications.prefs.showPopup'
  //   ]?.value

  //todo: for local notification debug, remove when no needed, ws notification does not work locally
  // useEffect(() => {
  //   notify(
  //     <NotificationBody
  //       notification={commentedPostNotification.data as unknown as Notification}
  //       isPopup
  //     />,
  //     {},
  //   )
  // }, [])

  const notifications = useSelector(
    notificationsSlice.selectors.selectNotifications,
  )

  const { user } = useCurrentUser()
  const subscriptionName = `${topic}#${user?.id}`

  const notification = useSelector((state: WsSliceState) =>
    wsSlice.selectors.selectLastUpdateFor(state, {
      subscriptionName,
      mode: 'equals',
    }),
  ) as WsOnMessage<Notification> | undefined

  useEffect(() => {
    if (!user?.id) return

    dispatch(
      wsSubscribe({
        id: subscriptionName,
        topics: [topic],
      }),
    )

    return () => {
      dispatch(wsUnSubscribe(subscriptionName))
    }
  }, [user?.id])

  useEffect(() => {
    if (!notification?.data) return

    const isUndo = isUndoNotification(notification)

    if (isUndo) {
      dispatch(undoNotification(notification.data as unknown as string))

      return
    }

    const isExist =
      (notification?.data.type === 'LIKE' &&
        notifications?.find(
          (n) =>
            n.activityId === notification?.data.activityId &&
            n.fromUser?.id === notification.data.fromUser?.id,
        )) ||
      notifications?.find((n) => n.id === notification.data.id)

    if (isExist) return

    dispatch(addNotification(notification.data))

    canNotify &&
      notify(<NotificationBody notification={notification.data} isPopup />, {})
  }, [notification?.data, canNotify])
}

export default useNotifications
